'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _Constants = require('./Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 插件框架配置
 * 
 * @ignore
 * @export
 * @class MinimaConfiguration
 */
var MinimaConfiguration = function MinimaConfiguration() {
    (0, _classCallCheck3.default)(this, MinimaConfiguration);
};

/*
{
    "type": 'console',
    "category": 'console'
},
{
    "category": "log_file",
    "type": "file",
    "filename": "./log.log",
    "maxLogSize": 104800,
    "backups": 100
},
{
    "category": "log_date",
    "type": "dateFile",
    "filename": "./log",
    "alwaysIncludePattern": true,
    "pattern": "-yyyy-MM-dd-hh.log"
}*/


MinimaConfiguration.startLevel = _Constants2.default.defaultFrameworkStartLevel;
MinimaConfiguration.log = {
    appenders: [{ type: 'console' }, {
        category: 'log',
        type: 'file',
        filename: _path2.default.resolve('./log.log'),
        maxLogSize: 104800,
        backups: 3
    }],
    replaceConsole: true,
    levels: {
        console: 'ALL'
    }
};
exports.default = MinimaConfiguration;
//# sourceMappingURL=MinimaConfiguration.js.map